import { render, staticRenderFns } from "./dateStartFlatPickr.vue?vue&type=template&id=87aa60bc&"
import script from "./dateStartFlatPickr.vue?vue&type=script&lang=js&"
export * from "./dateStartFlatPickr.vue?vue&type=script&lang=js&"
import style0 from "./dateStartFlatPickr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports